export const inventoryReasons = [
  'DAMAGE',
  'GIFT',
  'SALE',
  'LOSS',
  'USAGE',
  'TRADE',
] as const

export type InventoryReason = (typeof inventoryReasons)[number]

export const transactionTypes = ['IN', 'OUT']

export const inventoryUnits = [
  'unit',
  'pcs',
  'box',
  'kg',
  'g',
  'liters',
  'meters',
  'packs',
  'bottles',
  'cans',
  'rolls',
  'sets',
  'others',
]

export const inventoryReasonLabels = {
  DAMAGE: 'Damaged',
  GIFT: 'Gifted/Donated',
  SALE: 'Sold',
  LOSS: 'Lost',
  USAGE: 'Used/Consumed',
  TRADE: 'Traded between churches',
} satisfies Record<InventoryReason, string>
